import React from "react";
import { AnimatePresence, motion } from "framer-motion";
import { CtaButton } from "./CtaButton";
import { product } from "../data/landing";
type StickyOfferBarProps = {
  visible: boolean;
};
export function StickyOfferBar({
  visible
}: StickyOfferBarProps) {
  return <AnimatePresence data-id="element-173" data-mp="2k8nw6dhf2wk0">
      {visible && <motion.div initial={{
      y: "-100%"
    }} animate={{
      y: 0
    }} exit={{
      y: "-100%"
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 top-0 z-40 border-b border-line bg-white/95 shadow-[0_6px_20px_rgba(19,34,56,0.08)] backdrop-blur-md" data-id="element-174" data-mp="2k7uzk5c69nfl">
          <div className="mx-auto flex max-w-[1180px] items-center justify-between gap-3 px-4 py-2.5 sm:px-8" data-id="element-175" data-mp="26azdncato1i4">
            <div className="flex min-w-0 items-center gap-3" data-id="element-176" data-mp="21c4sw4tao2vd">
              <img src={product.mockup} alt="" aria-hidden="true" className="hidden h-11 w-auto rounded sm:block" data-id="element-177" data-mp="4h034t5ixo6h" />
              <p className="min-w-0 leading-tight" data-id="element-178" data-mp="oo5tsn8plfca">
                <span className="block truncate font-display text-lg font-bold uppercase text-navy" data-id="element-179" data-mp="tns5gs8w2niz">{product.name}</span>
                <span className="text-xs text-muted" data-id="element-180" data-mp="fp0uhepbphz2">
                  10 workshops + 5 bonuses ·{" "}
                  <strong className="text-navy" data-id="element-181" data-mp="kmkaok5l04tn">
                    ${product.price} {product.currency}
                  </strong>
                </span>
              </p>
            </div>
            <CtaButton href="#offer-details" size="sm" data-id="element-182" data-mp="1cf1ihbhvbufb">
              Get the kit
            </CtaButton>
          </div>
        </motion.div>}
    </AnimatePresence>;
}